import { TaskTableColumn, TaskTableConfig } from './types';

/**
 * Configuration preset for My Tasks view
 * - Shows RACI roles
 * - Shows Created At and Completed At timestamps
 * - Enables completion and deletion
 * - Shows project names
 * - Mobile responsive
 */
export const MY_TASKS_CONFIG: TaskTableConfig = {
  columns: [
    TaskTableColumn.CHECKBOX,
    TaskTableColumn.TASK,
    TaskTableColumn.CATEGORY,
    TaskTableColumn.PRIORITY,
    TaskTableColumn.STATUS,
    TaskTableColumn.CREATED_AT,
    TaskTableColumn.START_DATE,
    TaskTableColumn.DUE_DATE,
    TaskTableColumn.COMPLETED_AT,
    TaskTableColumn.ASSIGNED,
    TaskTableColumn.ACTIONS,
  ],
  enableCompletion: true,
  enableDeletion: true,
  enableTimer: true,
  mobileEnabled: true,
  showProjectName: true,
  enableSelection: true,
};

/**
 * Configuration preset for Project Tasks view
 * - Shows Issue Type and Links (dependencies)
 * - Shows Completed At timestamp
 * - View-only mode (no completion/deletion via table)
 * - No RACI column
 * - Desktop only (mobile to be added later)
 */
export const PROJECT_TASKS_CONFIG: TaskTableConfig = {
  columns: [
    TaskTableColumn.CHECKBOX,
    TaskTableColumn.TASK,
    TaskTableColumn.CATEGORY,
    TaskTableColumn.ISSUE_TYPE,
    TaskTableColumn.PRIORITY,
    TaskTableColumn.STATUS,
    TaskTableColumn.LINKS,
    TaskTableColumn.START_DATE,
    TaskTableColumn.DUE_DATE,
    TaskTableColumn.COMPLETED_AT,
    TaskTableColumn.ASSIGNED,
    TaskTableColumn.ACTIONS,
  ],
  enableCompletion: true,
  enableDeletion: true,
  enableTimer: true,
  mobileEnabled: false, // To be added in future
  showProjectName: false,
  enableSelection: true,
};
